import React from 'react';
import { Colors, TouchableRipple } from 'react-native-paper';
import { appColors } from '../../assets/styles/global';
import { pixelDimensions } from '../../config/utils';
import AppText from './AppText';

const AppButton = ({
  style,
  onPress,
  disabled,
  children,
  label,
  labelStyle,
  rippleColor,
  size,
  disableDefaultColor,
  isCircle,
  primary,
}) => (
  <TouchableRipple
    disabled={disabled}
    onPress={onPress}
    rippleColor={rippleColor || Colors.white}
    style={[
      disableDefaultColor
        ? {
          opacity: disabled ? 0.7 : 1,
          borderRadius: isCircle ? pixelDimensions(50) : pixelDimensions(3),
        }
        : {
          opacity: disabled ? 0.7 : 1,
          borderRadius: isCircle ? pixelDimensions(50) : pixelDimensions(3),
          backgroundColor: appColors.primary,
        },
      primary && { backgroundColor: appColors.primary },
      style,
    ]}
    borderless
  >
    {label ? (
      <AppText size={size} style={labelStyle}>
        {label}
      </AppText>
    ) : (
      children
    )}
  </TouchableRipple>
);

export default AppButton;
